
declare const fbq;
declare let gtag: Function; // Declare ga as a function

/* @ngInject */
export default class FacebookPixelService {

    constructor() { }

    public sendFBEvent(status, properties: Object) {
        if (typeof fbq === 'undefined') {
            return;
        }
        fbq('track', status, properties);
        this.googleEventEmitter(); 
    }


    public googleEventEmitter() {
        if (typeof gtag === 'undefined') {
            return;
        }
        gtag('event', 'conversion', {
            'send_to': 'AW-928952608/WOtfCPG_1bUBEKDi-roD'
        });
    }
 

    /* load() {
         (function (f: any, b, e, v, n, t, s) {
             if (f.fbq) return; n = f.fbq = function () {
                 n.callMethod ?
                     n.callMethod.apply(n, arguments) : n.queue.push(arguments)
             }; if (!f._fbq) f._fbq = n;
             n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
             t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
         })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
         (window as any).fbq.disablePushState = true; //not recommended, but can be done
         (window as any).fbq('init', '<your id>');
         (window as any).fbq('track', 'PageView');
     }*/
}


// WEBPACK FOOTER //
// src/app/common/services/analytics/facebook-analytics.service.ts